import { render, staticRenderFns } from "./Paas-Publica.vue?vue&type=template&id=9c86e5e0&scoped=true&"
import script from "./Paas-Publica.vue?vue&type=script&lang=js&"
export * from "./Paas-Publica.vue?vue&type=script&lang=js&"
import style0 from "./Paas-Publica.vue?vue&type=style&index=0&id=9c86e5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c86e5e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
